export interface DynamicChart<T = any> {
  title?: string;
  variant: ChartVariant;
  width?: string;
  height?: string;
  data?: T;
}

export enum ChartVariant {
  PIE = 'pie',
  DOUGHNUT = 'doughnut',
  LINE = 'line',
  EMPTY = 'empty',
}

export interface PieChartProps {
  labels: string[];
  values: number[];
  backgroundColors: string[];
  hoverBackgroundColors?: string[];
  labelPosition?: 'top' | 'bottom' | 'left' | 'right';
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface DoughnutChartProps extends PieChartProps {}

export interface LineChartProps {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    borderColor?: string;
    backgroundColor?: string;
    tension?: number;
    fill?: boolean;
  }[];
}
